/**
 * @generated SignedSource<<93a1277a31c9431b369d41f99f3fffef>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  qualifier?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type GroupedUsersGridQuery$variables = {
  searchFilter?: FilterElementInput | null | undefined;
  searchFirst?: number | null | undefined;
};
export type GroupedUsersGridQuery$data = {
  readonly total: {
    readonly pageInfo: {
      readonly total: number | null | undefined;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"GroupedUsersGridSearchFragment">;
};
export type GroupedUsersGridQuery = {
  response: GroupedUsersGridQuery$data;
  variables: GroupedUsersGridQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchFirst"
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "searchFirst"
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  (v2/*:: as any*/)
],
v4 = {
  "alias": "total",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "users",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": "users(first:1)"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "idpNamespace",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GroupedUsersGridQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "searchFilter"
          },
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GroupedUsersGridSearchFragment"
      },
      (v4/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "GroupedUsersGridQuery",
    "selections": [
      {
        "alias": "searchUsers",
        "args": [
          {
            "kind": "Variable",
            "name": "filterElement",
            "variableName": "searchFilter"
          },
          (v1/*:: as any*/)
        ],
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "users",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "APIKeyConnection",
                    "kind": "LinkedField",
                    "name": "apiKeys",
                    "plural": false,
                    "selections": (v3/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserIdentityLink",
                    "kind": "LinkedField",
                    "name": "identityLinks",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          (v6/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastLogin",
                    "storageKey": null
                  },
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": (v9/*:: as any*/),
                    "concreteType": "UserGroupConnection",
                    "kind": "LinkedField",
                    "name": "userGroups",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              (v7/*:: as any*/),
                              (v8/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": [
                                  (v5/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "idpAlias",
                                    "storageKey": null
                                  },
                                  (v6/*:: as any*/),
                                  (v7/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "uuid",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "userGroups(first:100)"
                  },
                  {
                    "alias": null,
                    "args": (v9/*:: as any*/),
                    "concreteType": "RoleAssignmentConnection",
                    "kind": "LinkedField",
                    "name": "roleAssignments",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleAssignmentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleAssignment",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  (v8/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "system",
                                    "storageKey": null
                                  },
                                  (v7/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "roleAssignments(first:100)"
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      (v4/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "6c95dcaf9d0ee000dc0a863808e9b10f",
    "id": null,
    "metadata": {},
    "name": "GroupedUsersGridQuery",
    "operationKind": "query",
    "text": "query GroupedUsersGridQuery(\n  $searchFilter: FilterElementInput\n  $searchFirst: Int\n) {\n  ...GroupedUsersGridSearchFragment_272xFY\n  total: users(first: 1) {\n    pageInfo {\n      total\n    }\n  }\n}\n\nfragment GroupedUsersGridSearchFragment_272xFY on Query {\n  searchUsers: users(filterElement: $searchFilter, first: $searchFirst) {\n    edges {\n      node {\n        apiKeys {\n          pageInfo {\n            total\n          }\n        }\n        email\n        identityLinks {\n          provider {\n            __typename\n            idpNamespace\n            id\n          }\n        }\n        key\n        lastLogin\n        name\n        userGroups(first: 100) {\n          edges {\n            node {\n              displayName\n              id\n              name\n              source {\n                __typename\n                idpAlias\n                idpNamespace\n                id\n              }\n              uuid\n            }\n          }\n        }\n        roleAssignments(first: 100) {\n          edges {\n            node {\n              role {\n                name\n                system\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n    pageInfo {\n      total\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a2f3d77ff449ff7a01cde65ba9994ff";

export default node;
